import api from './api';

const BASE = '/consumo';

export const consumoService = {
    // Subir PDF con almacén, período
    subirPDF: async (tipo, archivo, almacen, periodo) => {
        const formData = new FormData();
        formData.append('archivo', archivo);
        let url = `${BASE}/upload?tipo=${tipo}`;
        if (almacen) url += `&almacen=${encodeURIComponent(almacen)}`;
        if (periodo) url += `&periodo=${encodeURIComponent(periodo)}`;
        const response = await api.post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },

    // Listar consumos (filtrar por tipo y meses)
    listar: async (tipo = null, meses = 3) => {
        const params = { meses };
        if (tipo) params.tipo = tipo;
        const response = await api.get(BASE + '/', { params });
        return response.data;
    },

    // Obtener uno por id
    obtener: async (id) => {
        const response = await api.get(`${BASE}/${id}`);
        return response.data;
    },

    // Actualizar datos manualmente
    actualizar: async (id, datos) => {
        const response = await api.put(`${BASE}/${id}`, datos);
        return response.data;
    },

    // Eliminar registro y archivo
    eliminar: async (id) => {
        const response = await api.delete(`${BASE}/${id}`);
        return response.data;
    },

    // URL de descarga del PDF
    urlDescarga: (id) => {
        const base = process.env.REACT_APP_API_URL || 'https://apifractial.homedeliverype.com/api/v1';
        const token = localStorage.getItem('access_token');
        return `${base}/consumo/${id}/descargar?token=${token}`;
    },

    // Descarga el archivo original (PDF/Excel/CSV) como blob, respetando el tipo del backend
    descargarPDF: async (id, nombreArchivo) => {
        const response = await api.get(`${BASE}/${id}/descargar`, {
            responseType: 'blob',
        });
        const mime = response.data.type || response.headers?.['content-type'] || 'application/octet-stream';
        const url = window.URL.createObjectURL(new Blob([response.data], { type: mime }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', nombreArchivo || `recibo_${id}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },

    // Generar reporte de resumen
    reporte: async (tipo = null, meses = 3) => {
        const params = { meses };
        if (tipo) params.tipo = tipo;
        const response = await api.get(`${BASE}/reporte/resumen`, { params });
        return response.data;
    },

    // ─── Consumo por almacén (kWh / m³ / Sm³ / otro) ─────────────────────────

    // Guardar consumo por almacén. entradas = [{almacen, kwh, tarifa_kwh}, ...]
    // El campo `kwh` representa la cantidad en la unidad correspondiente al tipo.
    guardarKWH: async (periodo, entradas, tipo = 'energia') => {
        const url = `${BASE}/kwh/guardar?periodo=${encodeURIComponent(periodo)}&tipo=${encodeURIComponent(tipo)}`;
        const response = await api.post(url, entradas);
        return response.data;
    },

    listarKWH: async (periodo = null, tipo = null) => {
        const params = {};
        if (periodo) params.periodo = periodo;
        if (tipo) params.tipo = tipo;
        const response = await api.get(`${BASE}/kwh/listar`, { params });
        return response.data;
    },

    periodosKWH: async (tipo = null) => {
        const params = tipo ? { tipo } : {};
        const response = await api.get(`${BASE}/kwh/periodos`, { params });
        return response.data;
    },

    eliminarKWH: async (id) => {
        const response = await api.delete(`${BASE}/kwh/${id}`);
        return response.data;
    },

    // ─── Residuos: registro diario por foto (IA de visión estima peso y tipo) ─

    subirFotoResiduo: async (almacen, file, fecha = null) => {
        const formData = new FormData();
        formData.append('file', file);
        const params = { almacen };
        if (fecha) params.fecha = fecha;
        const response = await api.post(`${BASE}/residuos/foto`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            params,
        });
        return response.data;
    },

    listarFotosResiduo: async (almacen = null, periodo = null) => {
        const params = {};
        if (almacen) params.almacen = almacen;
        if (periodo) params.periodo = periodo;
        const response = await api.get(`${BASE}/residuos/fotos`, { params });
        return response.data;
    },

    statsKWH: async () => {
        const response = await api.get(`${BASE}/kwh/stats/dashboard`);
        return response.data;
    },
};
